<section class="selector-section">
    <h4>
        <lib-toggle-switch class="switch" [value]="allEnabled$" direction="left" #toggle>RELATION TYPES:</lib-toggle-switch>
    </h4>
    <div class="chips">
        <lib-chip *ngFor="let chip of typeChips$ | async" [chip]="chip" (clicked)="onChipClick($event)"></lib-chip>
    </div>
</section>